export enum SprintStatusEnum {
	UPCOMING = 'UPCOMING',
	ACTIVE = 'ACTIVE',
	CLOSED = 'CLOSED',
}
